// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6 3H3V23H13.8762C13.0139 21.897 12.5 20.5085 12.5 19C12.5 15.4101 15.4101 12.5 19 12.5C19.6978 12.5 20.3699 12.61 21 12.8135V3H18V7H6V3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M24 20H20V24H18V20H14V18H18V14H20V18H24V20Z"}}]};

const TaskAddFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-add-filled',
    ref,
    icon: element,
  },
));

TaskAddFilledIcon.displayName = 'TaskAddFilledIcon';

export default TaskAddFilledIcon;
